// Global Mixins
const mixins = {
    methods: {
        isOneOfTheseRoles(roles) {
            let authorized = false;
            if (roles == null) {
                return true;
            }
            roles.forEach((value, index, array) => {
                // if the user is directly one of the roles
                if (value === this.$store.getters.role) {
                    authorized = true;
                } else if (this.$store.state.admins.includes(this.$store.getters.role)) { // if they are an admin
                    const rolesAdminsDontHaveAccess = ['cake', 'guest'];
                    if (rolesAdminsDontHaveAccess.includes(value)) {
                        authorized = false;
                    } else { authorized = true; }
                } else if (this.$store.state.roleGroups.includes(value)) { // if the input role was a rolesGroup
                    // if the input rolesGroup has this users primary role in it, return true
                    if (this.$store.state[value].includes(this.$store.getters.role)) {
                        authorized = true;
                    }
                }
            });

            return authorized;
        },
        isOneOfTheseParishRoles(roles) {
            let authorized = false;
            if (roles == null) {
                return true;
            }
            roles.forEach((value, index, array) => {
                if (value === this.$store.getters.role && this.$store.getters.isParish) {
                    authorized = true;
                } else if (this.$store.state.admins.includes(this.$store.getters.role)) { // if they are an admin
                    const rolesAdminsDontHaveAccess = ['cake', 'guest'];
                    if (rolesAdminsDontHaveAccess.includes(value)) {
                        authorized = false;
                    } else { authorized = true; }
                }
            });

            return authorized;
        },
        transformJSDateForPayload(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        }
    }
};

export default mixins;
